<template>
  <validation-observer v-slot="{ invalid }">
    <v-row>
      <v-subheader class="font-weight-bold">Filter report by:</v-subheader>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3">
        <date-picker
          :value="startDate"
          :field="{ label: 'Start Date' }"
          @fieldChange="startDate = $event"
          :validations="validations.startDate"
        ></date-picker>
      </v-col>
      <v-col cols="12" sm="3">
        <date-picker
          :value="endDate"
          :field="{ label: 'End Date' }"
          @fieldChange="endDate = $event"
          :validations="validations.endDate"
        ></date-picker>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3">
        <v-autocomplete
          v-model="selectedPrograms"
          :items="programOptions"
          :item-text="(item) => `${item.code} - ${item.name}`"
          item-value="programId"
          label="Programs"
          multiple
          small-chips
          clearable
          deletable-chips
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3">
        <v-autocomplete
          v-model="selectedServices"
          :items="serviceOptions"
          :item-text="(item) => `${item.code} - ${item.name}`"
          item-value="serviceId"
          label="Services"
          multiple
          small-chips
          clearable
          deletable-chips
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-btn
        color="primary"
        :dark="!invalid"
        :disabled="invalid"
        outlined
        rounded
        @click="downloadReport"
        >Download Report</v-btn
      >
    </v-row>
  </validation-observer>
</template>
<script>
import { downloadFile } from "../../utils/download-utils";
import { formatDate } from "../../utils/format-utils";
export default {
  data() {
    return {
      startDate: null,
      endDate: null,
      selectedPrograms: [],
      selectedServices: [],
    };
  },
  computed: {
    validations() {
      return {
        startDate: {
          required: true,
        },
        endDate: {
          required: true,
          minDate: this.startDate,
        },
      };
    },
    programOptions() {
      return this.$store.state.optionsModule.programs;
    },
    serviceOptions() {
      return this.$store.state.optionsModule.services;
    },
    fileName() {
      return (
        "SessionsNotBilled " +
        formatDate(this.startDate) +
        " through " +
        formatDate(this.endDate) +
        ".csv"
      );
    },
  },
  methods: {
    async downloadReport() {
      this.$store.commit("uxModule/setShowLoader", true);
      var response = await this.$store.dispatch(
        "reportsModule/getSessionsNotBilledReport",
        {
          start: this.startDate,
          end: this.endDate,
          programs: this.selectedPrograms,
          services: this.selectedServices,
        }
      );

      if (response) {
        await downloadFile(response, this.fileName);
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Oops! Something went wrong. Please try again later."
        );
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
      this.$store.commit("uxModule/setShowLoader", false);
    },
  },
};
</script>
